import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

import router from "@/router";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

onMounted(() => {
  router.push("/agendar");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})